import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import uuid from 'uuid';
import tlds from 'tlds';
import Linkify from 'linkify-it';
import EntityTypes from '../../types/EntityTypes';
import { LinkIcon } from '../../components/Icons';
import processSliteUrl from '../utils/processSliteUrl';
var linkify = Linkify().tlds(tlds).set({
  fuzzyIP: true
});
export default function LinkStrategy(_ref) {
  var fetchNotes = _ref.fetchNotes,
      editor = _ref.editor,
      appDomain = _ref.appDomain,
      organizationDomain = _ref.organizationDomain,
      showNoteByToken = _ref.showNoteByToken;

  function handlePublicShareLink(editor, _ref2) {
    var publicShareToken = _ref2.publicShareToken;
    var entityId = uuid();
    editor.unwrapInline(EntityTypes.NOTELINK).wrapInline({
      type: EntityTypes.NOTELINK,
      data: {
        entityId: entityId
      }
    }).moveToEnd().focus();

    var callback = function callback() {
      var additionalData, _ref3, result, node;

      return _regeneratorRuntime.async(function callback$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              additionalData = {};
              _context.prev = 1;
              _context.next = 4;
              return _regeneratorRuntime.awrap(showNoteByToken({
                token: publicShareToken
              }));

            case 4:
              _ref3 = _context.sent;
              result = _ref3.result;
              additionalData.noteId = result.data.showNoteByToken.id;
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);

              if (_context.t0.error && _context.t0.error.errors[0].status === 404) {
                additionalData.notFound = true;
              }

            case 12:
              node = editor.value.document.findDescendant(function (child) {
                return child.object === 'inline' && child.getIn(['data', 'entityId']) === entityId;
              });

              if (node) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return", null);

            case 15:
              return _context.abrupt("return", editor.setNodeByKey(node.key, {
                data: node.data.merge(additionalData)
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, [[1, 9]]);
    };

    return editor.command('addOnSyncDoneCallback', callback);
  }

  var strategy = {
    index: 1,
    apply: function apply(item, _) {
      var _processSliteUrl = processSliteUrl(item.data.value, {
        appDomain: appDomain,
        organizationDomain: organizationDomain
      }),
          noteId = _processSliteUrl.noteId,
          publicShareToken = _processSliteUrl.publicShareToken,
          blockId = _processSliteUrl.blockId;

      editor.command('hidePrompt');

      if (publicShareToken) {
        return handlePublicShareLink(editor, {
          publicShareToken: publicShareToken
        });
      }

      var insertNoteLink = item.type === 'notes' || noteId;
      var entityType = insertNoteLink ? EntityTypes.NOTELINK : EntityTypes.LINK;
      var data = insertNoteLink ? {
        noteId: noteId || item.data.id,
        blockId: blockId
      } : {
        url: item.data.value
      };
      return editor.unwrapInline(entityType).wrapInline({
        type: entityType,
        data: data
      }).moveToEnd().focus();
    },
    search: function search(query) {
      var notes;
      return _regeneratorRuntime.async(function search$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime.awrap(fetchNotes(query));

            case 2:
              notes = _context2.sent;
              return _context2.abrupt("return", notes.map(function (noteData, index) {
                return {
                  type: 'notes',
                  data: noteData,
                  strategy: strategy,
                  // Preserve search index
                  index: index + strategy.index + 2
                };
              }).concat(linkify.match(query) ? [{
                type: 'link',
                data: {
                  value: query,
                  id: uuid(),
                  title: query
                },
                strategy: strategy,
                index: strategy.index + 1,
                renderTitle: function renderTitle() {
                  return React.createElement("div", {
                    className: "ellipsis"
                  }, "Link to \"".concat(query, "\""));
                },
                renderSubtitle: function renderSubtitle() {},
                renderIcon: function renderIcon(_ref4) {
                  var width = _ref4.width;
                  return React.createElement("div", {
                    style: {
                      width: width,
                      height: width,
                      lineHeight: '20px',
                      padding: '0 6px'
                    },
                    className: "flexbox-no-grow flexbox-no-shrink center-text shade-20"
                  }, React.createElement(LinkIcon, {
                    size: "16"
                  }));
                }
              }] : []));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      });
    },
    tokenize: function tokenize(item) {
      return (item.data.title || '').toLowerCase();
    }
  };
  return strategy;
}